import { css } from 'styled-components';

export const inputProps = css`
  margin-top: 15px;
`;

export const contentProps = css`
  padding: 20px 25px;
`;
